<template>
  <div class="newsletter-section q-py-xl q-mb-md bg-grey-2 q-pa-lg rounded-borders shadow-2">
    <div class="row items-center">
      <div class="col-md-7">
        <h2 class="text-h4">Never Miss a Deal</h2>
        <p class="q-mb-md text-subtitle1">Subscribe to our newsletter for the latest coupons delivered to your inbox.</p>
      </div>
      <div class="col-md-5">
        <q-form @submit.prevent="submitForm" class="row q-col-gutter-md">
          <div class="col-md-8">
            <q-input 
              v-model="emailProxy"
              outlined
              dense
              bg-color="white"
              label="Your Email Address"
              placeholder="email@example.com"
              :rules="[val => validateEmail(val) || 'Please enter a valid email']"
              lazy-rules
            />
          </div>
          <div class="col-md-4">
            <q-btn 
              type="submit" 
              label="Subscribe" 
              color="primary" 
              class="full-width"
              :disable="!emailProxy || !validateEmail(emailProxy)"
              no-caps
            />
          </div>
        </q-form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
  email: String,
  modelValue: String,
  validateEmail: { type: Function, required: true },
});
const emit = defineEmits(['update:email', 'update:modelValue', 'submit']);
const emailProxy = computed({
  get: () => props.email ?? props.modelValue,
  set: val => { emit('update:email', val); emit('update:modelValue', val); }
});
const submitForm = () => {
  if (props.validateEmail(emailProxy.value)) {
    emit('submit');
  }
};
</script>
